
import { useRoute } from "vue-router";
import { qualityService } from "@/service";
import { defineComponent, ref } from "vue";
import DetailInfo from "./detail/info.vue";
import { ImagePreview } from "vant";

export default defineComponent({
  components: {
    DetailInfo
  },
  setup() {
    const activeIndex = ref(0);
    const selectList = ref([]);
    const currentSelect = ref();

    const detail = ref();
    const route = useRoute();
    const getDetail = async () => {
      const { data } = await qualityService.pool_detail({
        id: route.query.id,
        check_log: 1,
        recheck_num: route.query.recheck_num
      });
      detail.value = data.data;

      selectList.value = data.data.order_lists.map((i: any) => ({
        text: `${i.item_name} ${i.record_num}/${i.norm_num}`
      }));

      clickNav(0);
    };

    const clickNav = async (index: number) => {
      const current = detail.value.order_lists[index];
      const { data } = await qualityService.order_detail({ id: current.id });
      currentSelect.value = data.data;
    };

    getDetail();

    const clickImage = (startPosition: number, list: any) => {
      const images = list.map((i: any) => i.photo_file);
      ImagePreview({ images, startPosition });
    };

    return {
      detail,
      activeIndex,
      selectList,
      currentSelect,
      clickNav,
      clickImage
    };
  }
});
